import { z } from "zod";

export const symptomCodes = [
  "C_F_D_Diary_Cold",
  "C_F_D_Diary_EarPain",
  "C_F_D_Diary_FeelingSick",
  "C_F_D_Diary_Fever",
  "C_F_D_Diary_DryCough",
  "C_F_D_Diary_FlemCough",
  "C_F_D_Diary_MorningCough",
  "C_F_D_Diary_StomachAche",
  "C_F_D_Diary_ThroatPain",
  "C_F_D_Diary_Tiredness",
  "C_F_D_Diary_NoSymtom",
] as string[];

export const SymptomDiarySchema = z.object({
  id: z.string(),
});

export type SymptomDiary = z.infer<typeof SymptomDiarySchema>;
